import { gql } from '@biletiniz/apollo';

export const LOGIN_CONFIRM = gql`
  mutation verifyLoginUser($session: String!, $confirmCode: String!) {
    verifyLoginUser(session: $session, confirmCode: $confirmCode) {
      message
      session
      status
      token {
        accessToken
        accessTokenExpiresAt
        refreshToken
        refreshTokenExpiresAt
        user {
          name
          surname
          email
          phoneNumber
          balance {
            amount
            currency
          }
        }
      }
    }
  }
`;
